import script from "./QTLiteAddCommentBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./QTLiteAddCommentBtn.vue?vue&type=script&setup=true&lang=ts"

import "./QTLiteAddCommentBtn.vue?vue&type=style&index=0&id=41b775a2&lang=scss&scoped=true"
import "./QTLiteAddCommentBtn.vue?vue&type=style&index=1&id=41b775a2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41b775a2"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
